import React from "react";
import { SelectField } from "react-md";

const ReactMDSelectField = ({
  meta: { touched, error, warning },
  input,
  ...passThroughProps
}) => (
  <SelectField
    errorText={error || warning}
    error={touched && (!!error || !!warning)}
    {...input}
    {...passThroughProps}
  />
);

ReactMDSelectField.propTypes = {};
ReactMDSelectField.defaultProps = {};

export default ReactMDSelectField;



// WEBPACK FOOTER //
// ./src/common/components/ReactMDSelectField.jsx